import _ from 'lodash';
import mongoose from 'mongoose';
import { peopleCountMatrix } from '../constants';
import { IServiceGroupDocument } from '../schemas/serviceGroup';
import { ITripPricingElement } from '../schemas/trip-pricing';

export function preSave(this: IServiceGroupDocument) {
  if (this.isNew || this.isModified('pricing')) sortPricing(this);
}

function sortPricing(trip: IServiceGroupDocument) {
  const sortedPricing = _.sortBy(trip.pricing, ({ adults, children, infants }) => {
    const peopleCount = { adultCount: adults, childrenCount: children, infantCount: infants };
    return _.findIndex(peopleCountMatrix, peopleCount);
  }) as mongoose.Types.Array<ITripPricingElement>;
  trip.pricing = sortedPricing;
}
